<template>
    <div class="choose-map-content">
        <el-form class="data-form">
            <el-form-item>
                <el-autocomplete
                    class="inp"
                    popper-class="my-autocomplete"
                    v-model="state"
                    :fetch-suggestions="searchAddr"
                    placeholder="请输入地址"
                    :trigger-on-focus="false"
                    @select="handleSelect"
                >
                    <i class="el-icon-location-outline el-input__icon" slot="suffix" title="选择地址"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.title }}</div>
                        <span class="addr" v-if="item.address.length > 0">{{ item.address }}{{ item.category }}</span>
                        <span class="addr" v-else>{{ item.district }}</span>
                    </template>
                </el-autocomplete>
                <div class="map-show" ref="mapShow" id="map-show" style="height: 400px;width: 100%;"></div>
            </el-form-item>
        </el-form>
        <div class="mapinfo">
            <div class="mapinfo-item">
                <div class="mapinfo-item-info">
                    地址:{{mapsData.nearestPOI}}
                </div>
               <div class="mapinfo-item-info">
                    经度:{{mapsData.longitude}}
                </div>
               <div class="mapinfo-item-info">
                    纬度:{{mapsData.latitude}}
               </div>
            </div>
            <div class="mapinfo-btn">
                <el-button type="primary" @click="locationSave">保存</el-button>
                <el-button @click="handleCancel">取消</el-button>
            </div>
        </div>
    </div>
</template>

<script>
// import AMap from 'AMap';
import { suggestionSearch,contraryConvertGeocoder } from '@/data-model';
export default {
    name: 'ChooseMaps',
    props: {
        longitude: {
            type: Number
        },
        latitude: {
            type: Number
        },
        locationInfo: {
            type: Object
        },
        locationValue: {
            type: String
        }
    },
    data () {
        return {
            mapsData: {
                longitude: '',
                latitude: '',
                nearestPOI: '',
                nearestJunction: '',
                nearestRoad: '',
                address: ''

            },
            searchContent: '',
            restaurants: [],
            state: ''
        };
    },
    created () {
        if (this.locationValue && this.locationValue.length > 5) {
            let cur = JSON.parse(this.locationValue);
            this.mapsData = cur;
            // let center = [cur.longitude, cur.latitude];
            // this.initShowMap(center);
            this.$nextTick(() => {
                this.geCurrentPosiTx(cur.longitude,cur.latitude);//腾讯
            });
        } else {
            // this.geCurrentPosi();//高德
            this.$nextTick(() => {
                this.geCurrentPosiTx();//腾讯
            });
        }
    },
    methods: {
        // searchAddr (queryString, cb) {
        //     var _this = this;
        //     AMap.plugin('AMap.Autocomplete', () => {
        //         let autoOptions = {
        //             city: '全国'
        //         };
        //         let autoComplete = new AMap.Autocomplete(autoOptions); // 初始化autocomplete
        //         autoComplete.search(queryString, (status, result) => {
        //             if (result.info === 'OK') {
        //                 _this.restaurants = result.tips;
        //                 cb(_this.restaurants);
        //             }
        //         });
        //     });
        // },
        async searchAddr (queryString, cb) {
            let param = {keyword:queryString};
            let res = await suggestionSearch(param);
            if(res.status===0){
                cb(res.data);
            }else{
                this.$message.error('获取地址失败');
            }
            // AMap.plugin('AMap.Autocomplete', () => {
            //     let autoOptions = {
            //         city: '全国'
            //     };
            //     let autoComplete = new AMap.Autocomplete(autoOptions); // 初始化autocomplete
            //     autoComplete.search(queryString, (status, result) => {
            //         if (result.info === 'OK') {
            //             _this.restaurants = result.tips;
            //             cb(_this.restaurants);
            //         }
            //     });
            // });
        },
        initShowMap (center) {
            console.log(center);
            var map = new qq.maps.Map(document.getElementById("map-show"),{
                center:  new qq.maps.LatLng(center[1],center[0]),
                zoom: 17,
                pitch: 43.5,  //设置俯仰角
                rotation: 45,    //设置地图旋转角度
                viewMode:'2D'
            });
            var marker = new qq.maps.Marker({
                position: map.getCenter(),
                draggable: true,
                map: map
            });
            marker.setIcon("https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker-pink.png");
            // AMapUI.loadUI(['misc/PositionPicker'], PositionPicker => {
            //     this.snameMap = new AMap.Map('map-show', {
            //         zoom: 17,
            //         scrollWheel: false,
            //         center: center
            //     });
            //     let positionPicker = new PositionPicker({
            //         mode: 'dragMarker',
            //         map: this.snameMap
            //     });
            //     positionPicker.on('success', positionResult => {
            //         this.mapsData.longitude = positionResult.position.lng;
            //         this.mapsData.latitude = positionResult.position.lat;
            //         this.mapsData.nearestPOI = positionResult.nearestPOI;
            //         this.mapsData.nearestJunction = positionResult.nearestJunction;
            //         this.mapsData.nearestRoad = positionResult.nearestRoad;
            //         this.mapsData.address = positionResult.address;
            //         // this.$emit('getMapsData', this.mapsData);
            //     });
            //     positionPicker.on('fail', positionResult => {
            //         this.$message.error('地址选取失败');
            //     });
            //     positionPicker.start();
            // });
        },
        handleSelect (item) {
            // if (item.id === '') {
            //     this.$message.error('请选择详细地址');
            // } else {
            //     this.state = item.name;
            //     this.mapsData.longitude = item.location.lng;
            //     this.mapsData.latitude = item.location.lat;
            //     this.$emit('getMapsData', this.mapsData);
            //     let center = [item.location.lng, item.location.lat];
            //     this.initShowMap(center);
            // }
            if (item.id === '') {
                this.$message.error('请选择详细地址');
            } else {
                this.state = item.title;
                this.mapsData.longitude = item.location.lng;
                this.mapsData.latitude = item.location.lat;
                this.mapsData.nearestPOI = item.title;
                this.$emit('getMapsData', this.mapsData);
                let center = [item.location.lng, item.location.lat];
                this.initShowMap(center);
            }
        },
        geCurrentPosi () {
            // var _this = this;
            // var map = new AMap.Map('container', {
            //     resizeEnable: true
            // });
            // AMap.plugin('AMap.Geolocation', function () {
            //     var geolocation = new AMap.Geolocation({
            //         enableHighAccuracy: true, // 是否使用高精度定位，默认:true
            //         timeout: 5000 // 超过10秒后停止定位，默认：5s
            //     });
            //     map.addControl(geolocation);
            //     geolocation.getCurrentPosition(function (status, result) {
            //         if (status === 'complete') {
            //             let center = [result.position.lng, result.position.lat];
            //             _this.initShowMap(center);
            //         } else {
            //             // console.log(result);
            //             // 定位失败默认当前位置为首都
            //             let center = [116.405285, 39.904989];
            //             _this.initShowMap(center);
            //         }
            //     });
            // });
        },
        geCurrentPosiTx(longitude,latitude){
            let center='';
            // if(!longitude && !latitude){
            //     center=39.904989,116.405285;
            // }else{
            //     console.log("====");
            //     center=longitude,latitude;
            // }
            var map = new qq.maps.Map(document.getElementById("map-show"),{
                center:  longitude ? new qq.maps.LatLng(longitude,latitude):new qq.maps.LatLng(39.904989,116.405285),
                zoom: 17,
                pitch: 43.5,  //设置俯仰角
                rotation: 45,    //设置地图旋转角度
                viewMode:'2D'
            });
            var marker = new qq.maps.Marker({
                position: map.getCenter(),
                draggable: true,
                map: map
            });
            marker.setIcon("https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker-pink.png");
            // var marker = null;
            // if (!marker) {
            //     marker = new qq.maps.MultiMarker({
            //         id: 'marker-layer',
            //         map: map,
            //         styles: {
            //             "highlight": new qq.maps.MarkerStyle({
            //                 "src": "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker-pink.png"
            //             })
            //         },
            //         geometries: [{
            //             // "id": 'demo',
            //             // "styleId": 'marker',
            //             "position": new qq.maps.LatLng(39.916527,116.397128),
            //             // "properties": {
            //             //     "title": "marker"
            //             // }
            //         }]
            //     });
            // }
            let _this = this;
            qq.maps.event.addListener(marker, "dragend", function(event) {
                // 更新标记位置
                marker.setPosition(event.latLng);
                _this.contraryConvertGeocoder(event.latLng);
            });
            // // 初始化几何图形及编辑器
            // const editor = new TMap.tools.GeometryEditor({
            //     map, // 编辑器绑定的地图对象
            //     overlayList: [{
            //         overlay: marker, // 可编辑图层
            //         id: "marker",
            //         selectedStyleId: "highlight"  // 被选中的marker会变为高亮样式
            //     }],
            //     actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
            //     activeOverlayId: "marker", // 激活图层
            //     selectable: true,
            //     originalEvent:true

            // });
        },
        async contraryConvertGeocoder(latLng){
            let param = {location:latLng.lat+','+latLng.lng};
            let res = await contraryConvertGeocoder(param);
            if(res.status===0){
                let result = res.result;
                this.mapsData.address = result.address;
                this.mapsData.longitude = result.location.lat;
                this.mapsData.latitude = result.location.lng;
                this.mapsData.nearestPOI = result.address;
                // this.initShowMap([result.location.lat,result.location.lng]);
            }else{
                this.$Message.error('获取地址失败');
            }
        },
        locationSave () {
            this.$emit('saveLocationInfo', this.mapsData);
        },
        handleCancel () {
            this.$emit('cancelLocationInfo');
        }
    }
};
</script>

<style lang="less">
.choose-map-content{
    height: 520px;
    display: block;
    .mapinfo{
        margin-top: 10px;
        .mapinfo-btn{
            text-align: center;
            margin-top: 10px;
        }
        .mapinfo-item{
           display: flex;
           .mapinfo-item-info{
               margin-right: 10px;
           }
        }
    }
}
.amap-copyright,
.amap-logo {
    display: none !important;
}
.inp {
    width: 100%;
}
.my-autocomplete {
    li {
        line-height: normal;
        padding: 7px;

        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .addr {
            font-size: 12px;
            color: #b4b4b4;
        }

        .highlighted .addr {
            color: #ddd;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/FieldProps/ChooseMaps.vue